import { render, staticRenderFns } from "./NavbarUser.vue?vue&type=template&id=28ae3a9e&scoped=true&"
import script from "./NavbarUser.vue?vue&type=script&lang=js&"
export * from "./NavbarUser.vue?vue&type=script&lang=js&"
import style0 from "./NavbarUser.vue?vue&type=style&index=0&id=28ae3a9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae3a9e",
  null
  
)

export default component.exports